import React from "react";
import { withRouter } from "react-router-dom";
import { Button, CircleButton } from "../../ecosystem";

const GetCareButton = ({
    fluid,
    icon,
    label,
    onClick,
    variant = "default"
}) => {


    return (
        <div className="get-care-btn-wrapper">
            {variant === "circle"
                ? <CircleButton icon={icon}
                    onClick={onClick} colorStyle="inverse">{label}</CircleButton>
                : <Button icon={icon} fluid={fluid}
                    onClick={onClick}>{label}</Button>
            }
        </div>
    );
}

export default withRouter(GetCareButton);
